import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
});

keycloak.onAuthSuccess = function() {
  localStorage.setItem("accessToken", keycloak.token);
  localStorage.setItem("refreshToken", keycloak.refreshToken);
};

keycloak.onAuthRefreshSuccess = function() {
  localStorage.setItem("accessToken", keycloak.token);
  localStorage.setItem("refreshToken", keycloak.refreshToken);
};

keycloak.onAuthRefreshError = function () {
  keycloak.logout();
}

keycloak.onAuthError = function () {
  keycloak.logout();
}

keycloak.onTokenExpired = async () => {
  await keycloak.updateToken(50);
}

export default keycloak;
